<template>
  <div id="my_map"></div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState } from "vuex";

export default {
  name: "web-map",
  props: {},
  data() {
    return {
      centerZip: {},
      territoryColor: "",
      zipObjectsInTerritory: [],
      zipProtectedObjects: [],
      zipCodesAsArray: [],
      protectedZipCodesAsArray: [],
      zipCodesAsString: "",
      protectedZipCodesAsString: "",
    };
  },
  computed: {
    ...mapState(["territory", "globals"]),
  },
  watch: {
    "$store.state.territory.territory_edit.CenterZip": function (
      newValue,
      oldValue
    ) {
      if (newValue) {
        this.loadMap(this);
      }
    },
    "$store.state.territory.territory_edit.TerritoryColor": function (
      newValue,
      oldValue
    ) {
      if (newValue) {
        this.territoryColor = this.hexToRGBA(newValue, 1);
      }
    },
    "$store.state.territory.territory_edit.DefaultRadius": function (
      newValue,
      oldValue
    ) {
      this.refreshWait(newValue);
    },
  },
  methods: {
    refreshWait(newRadius) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.loadMap(this);
      }, 2000);
    },
    saveField: function (_zip, _include) {
      var _operation = {
        TerritoryID: this.$store.state.territory.territory_edit.TerritoryID,
        ZipCode: _zip,
        Include: _include,
      };
      this.$store.dispatch("zip/setTerritoryZipStatus", _operation).then();
    },
    hexToRGBA(hex, opacity) {
      return (
        "rgba(" +
        (hex = hex.replace("#", ""))
          .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
          .map(function (l) {
            return parseInt(hex.length % 2 ? l + l : l, 16);
          })
          .concat(opacity || 1)
          .join(",") +
        ")"
      );
    },
    async getCenter() {
      await this.$store
        .dispatch(
          "territory/GetZipCoordinates",
          this.$store.state.territory.territory_edit.CenterZip
        )
        .then((response) => {
          this.centerZip = response.data["GetCoordinatesResult"];
        });
    },
    async loadTerritoryZips() {
      await this.$store
        .dispatch(
          "territory/GetTerritoryZips",
          this.$store.state.territory.territory_edit
        )
        .then((response) => {
          this.zipObjectsInTerritory = response.data["ZipsInTerritoryResult"];
          this.zipCodesAsArray = this.zipObjectsInTerritory.map(
            (a) => a.ZipCode
          );
          this.zipCodesAsString = this.zipCodesAsArray.toString();
        });
    },
     async loadProtectedZips() {
       await this.$store
        .dispatch(
          "zip/fetchProtectedZips");

          this.zipProtectedObjects = this.$store.state.zip.protected_zips;
          this.protectedZipCodesAsArray = this.zipProtectedObjects.map(
            (a) => a.ZipCode
          );
          this.protectedZipCodesAsString = this.protectedZipCodesAsArray.toString();
    },
    async loadMap(_vue) {
      // lazy load the required ArcGIS API for JavaScript modules and CSS
      await this.loadTerritoryZips();
      await this.loadProtectedZips();
      await this.getCenter().then(() => {
        loadModules(
          [
            "esri/Map",
            "esri/views/MapView",
            "esri/layers/FeatureLayer",
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/Color"
          ],
          { css: true }
        ).then(
          ([
            ArcGISMap,
            MapView,
            FeatureLayer,
            GraphicsLayer,
            Graphic,
            Color,
          ]) => {
            

            const territorymap = new ArcGISMap({
              basemap: "topo",
            });

            var zipcodes = new FeatureLayer({
              url:
                "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/USA_ZIP_Codes/FeatureServer/0",
            });

            var graphicsLayer = new GraphicsLayer();
            territorymap.add(graphicsLayer);

            var mouseover_graphicsLayer = new GraphicsLayer({
              labelingInfo: [zipcodeLabels],
            });
            territorymap.add(mouseover_graphicsLayer);

            var view = new MapView({
              container: "my_map",
              map: territorymap,
              center: [this.centerZip.Longitude, this.centerZip.Latitude],
              zoom: 4,
            });

            // view.when(function() {
            //   queryFeatureLayer(view.center, 15, "intersects", "1=1");
            // });

            var _whereClause = "ZIP = " + this.centerZip.ZipCode;

            var _whereClauseTerritoryZips =
              "ZIP in (" + this.zipCodesAsString + ")";

            // var _whereNotClauseTerritoryZips =
            //   "ZIP NOT in (" + this.zipCodesAsString + ") AND ZIP NOT in (" + this.protectedZipCodesAsString + ")";

             var _whereNotClauseTerritoryZips =
              "ZIP NOT in (" + this.zipCodesAsString + ")";
 

            var _whereProtectedClauseZips =
              "ZIP in (" + this.protectedZipCodesAsString + ") and ZIP not in (" + this.zipCodesAsString + ")";


            view.when(function () {
              var centerZipQuery = {
                geometry: view.center,
                distance:
                  _vue.$store.state.territory.territory_edit.DefaultRadius,
                units: "miles",
                spatialRelationship: "intersects",
                outFields: ["ZIP"],
                returnGeometry: true,
                where: _whereClause,
              };
              zipcodes
                .queryFeatures(centerZipQuery)
                .then(function (result) {
                  addGraphics(result, true);
                  zoomToGraphics(result, true);
                  //var _centerGeometry = result;
                }).then(function () {
                  var edit_query = {
                    geometry: view.center,
                    distance:
                      _vue.$store.state.territory.territory_edit.DefaultRadius,
                    units: "miles",
                    spatialRelationship: "intersects",
                    outFields: ["ZIP"],
                    returnGeometry: false
                  };
                  zipcodes.queryFeatures(edit_query).then(function (result) {
                    //addEditGraphics(result, true);
                    addMapGraphics(result, true);
                  });
                })
                // .then(function () {
                //   var query = {
                //     geometry: view.center,
                //     distance:
                //       _vue.$store.state.territory.territory_edit.DefaultRadius,
                //     units: "miles",
                //     spatialRelationship: "intersects",
                //     outFields: ["ZIP"],
                //     returnGeometry: true,
                //     where: _whereClauseTerritoryZips,
                //   };
                //   zipcodes.queryFeatures(query).then(function (result) {
                //     addGraphics(result, true);
                //   });
                // })
                // .then(function () {
                //   var protected_query = {
                //     geometry: view.center,
                //     distance:
                //       _vue.$store.state.territory.territory_edit.DefaultRadius,
                //     units: "miles",
                //     spatialRelationship: "intersects",
                //     outFields: ["ZIP"],
                //     returnGeometry: true,
                //     where: _whereProtectedClauseZips,
                //   };
                //   zipcodes.queryFeatures(protected_query).then(function (result) {
                //     addProtectedGraphics(result, true);
                //   });
                // })
                
            });

            function zoomToGraphics(result) {
              result.features.forEach(function (feature) {
                view.goTo(feature.geometry).then(function () {
                  view.scale = 24000;
                  view.zoom = 9;
                });
                graphicsLayer.removeAll();
              });
            }

            function queryFeatureLayer(
              point,
              distance,
              spatialRelationship,
              sqlExpression
            ) {
              var query = {
                geometry: point,
                distance: distance,
                units: "miles",
                spatialRelationship: spatialRelationship,
                outFields: ["ZIP"],
                returnGeometry: true,
                where: sqlExpression,
              };
              zipcodes.queryFeatures(query).then(function (result) {
                addGraphics(result, true);
              });
            }

            view.on("pointer-move", function (evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y,
              };

              // the hitTest() checks to see if any graphics in the view
              // intersect the given screen x, y coordinates
              view.hitTest(screenPoint).then(function (response) {
                //changeCursor(response);
                //console.log(response.ZIP);
                //console.log(response);
                getHoverGraphics(response);
              });
            });

            view.on("click", function (evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y,
              };

              // the hitTest() checks to see if any graphics in the view
              // intersect the given screen x, y coordinates
              view.hitTest(screenPoint).then(function (response) {
                //changeCursor(response);
                //console.log(response.ZIP);
                //console.log(response);
                getGraphics(response);
                // if (response.results.length) {
                //   response.results.forEach(function(_result) {
                //   });
                // }

                //   var zip_to_edit = response.results[0].graphic.attributes.ZIP;
                //   var _color_to_check =
                //     response.results[0].graphic.symbol.color;

                // }
              });
            });

            function getGraphics(response) {
              if (response.results.length) {
                response.results.forEach(function (_result) {
                  switch (_result.graphic.symbol.color) {
                    case _default_color:
                      _result.graphic.symbol = _territorySymbol;
                      _vue.saveField(_result.graphic.attributes.ZIP, true);
                      break;
                    case _color:
                      _result.graphic.symbol = _nonTerritorySymbol;
                      _vue.saveField(_result.graphic.attributes.ZIP, false);
                      break;
                  }
                });
              }
            }

            function getHoverGraphics(response) {
              // the topmost graphic from the click location
              // and display select attribute values from the
              // graphic to the user



              if (response.results.length) {
                
                var graphic = response.results[0].graphic;
                addSingleGraphic(graphic);
                // response.results.forEach(function(_result) {
                // });
              }
            }

            function addSingleGraphic(graphic) {
              mouseover_graphicsLayer.removeAll();
              // var g = new Graphic({
              //   geometry: graphic.geometry,
              //   attributes: graphic.attributes,
              //   symbol: {
              //     type: "simple-fill", // autocasts as new SimpleFillSymbol()
              //     color: [255, 128, 0, 0.7],
              //     outline: {
              //       // autocasts as new SimpleLineSymbol()
              //       width: 1,
              //       color: "black"
              //     }
              //   }
              // });

              var h = new Graphic({
                geometry: graphic.geometry,
                attributes: graphic.attributes,
                symbol: {
                  type: "text",
                  text: graphic.attributes["ZIP"],
                  font: {
                    size: 10,
                    weight: "bold",
                  },
                },
              });

 
                _vue.$store.dispatch(
                    "globals/setQueryByZip",
                    graphic.attributes["ZIP"]
                  );


              //mouseover_graphicsLayer.add(g);
              mouseover_graphicsLayer.add(h);
            }

            var zipcodeLabels = {
              symbol: {
                type: "text",
                color: "#000",
                font: {
                  size: "8px",
                  family: "Noto Sans",
                  style: "italic",
                  weight: "normal",
                },
              },
              labelPlacement: "center-center",
              labelExpressionInfo: {
                expression: "$feature.ZIP",
              },
            };

            var _color = new Color(this.territoryColor);
            var _default_color = new Color([255, 255, 255, 0.1]);
            var _territorySymbol = {
              type: "simple-fill",
              color: _color,
              outline: {
                width: 1,
                color: "black",
              },
            };

            var _nonTerritorySymbol = {
              type: "simple-fill",
              color: _default_color,
              outline: {
                width: 1,
                color: "black",
              },
            };

            var _protectedSymbol = {
               type: "simple-fill",
                    color: "#555",
                    outline: {
                      width: 1,
                      color: "black"
                    }
            };


            function addGraphics(result) {
              result.features.forEach(function (feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _territorySymbol,
                  // {
                  //   type: "simple-fill",
                  //   color: _color,
                  //   outline: {
                  //     width: 1,
                  //     color: "black"
                  //   }
                  // }
                });

                graphicsLayer.add(g);
              });
            }

            function addProtectedGraphics(result) {
              result.features.forEach(function (feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: 
                  {
                    type: "simple-fill",
                    color: "#555",
                    outline: {
                      width: 1,
                      color: "black"
                    }
                  }
                });

                graphicsLayer.add(g);
              });
            }

function addMapGraphics(result) {
              //graphicsLayer.removeAll();
              var _ziplist = "-1";
              result.features.forEach(function (feature) {
                _ziplist += ("," + feature.attributes["ZIP"]);
              })

              var _newWhereClauseZips =
              "ZIP in (" + _ziplist + ")";

              var real_query = {
                    outFields: ["ZIP"],
                    returnGeometry: true,
                    where: _newWhereClauseZips
                  };
                  zipcodes.queryFeatures(real_query).then(function (result) {
                    //addEditGraphics(result, true);
                    addEditGraphics(result, true);
                  });
              
}

            function addEditGraphics(result) {
              //graphicsLayer.removeAll();
              result.features.forEach(function (feature) {


                if (_vue.zipCodesAsArray.find(z => z === feature.attributes["ZIP"]))
{
         var h = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _territorySymbol,
                  // {
                  //   type: "simple-fill", // autocasts as new SimpleFillSymbol()
                  //   //color: [255, 128, 0, 0.1],
                  //   color: _default_color,
                  //   outline: {
                  //     // autocasts as new SimpleLineSymbol()
                  //     width: 1,
                  //     color: "black"
                  //   }
                  // }
                });

                graphicsLayer.add(h);

}
else
{
 if (_vue.protectedZipCodesAsArray.find(z => z === feature.attributes["ZIP"]))
 {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _protectedSymbol,
                  // {
                  //   type: "simple-fill", // autocasts as new SimpleFillSymbol()
                  //   //color: [255, 128, 0, 0.1],
                  //   color: _default_color,
                  //   outline: {
                  //     // autocasts as new SimpleLineSymbol()
                  //     width: 1,
                  //     color: "black"
                  //   }
                  // }
                });

 }
 else
 {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _nonTerritorySymbol,
                  // {
                  //   type: "simple-fill", // autocasts as new SimpleFillSymbol()
                  //   //color: [255, 128, 0, 0.1],
                  //   color: _default_color,
                  //   outline: {
                  //     // autocasts as new SimpleLineSymbol()
                  //     width: 1,
                  //     color: "black"
                  //   }
                  // }
                });


}
                graphicsLayer.add(g);
}
              });
            }
            
          }
        );
      });
    },
  },
  mounted() {
    if (this.$store.state.territory.territory_edit.TerritoryID > 0) {
      this.territoryColor = this.hexToRGBA(
        this.$store.state.territory.territory_edit.TerritoryColor,
        1
      );
      this.loadMap(this);
    }
    //   this.$store
    //     .dispatch("territory/GetZipCoordinates", "32033")
    //     .then(response => {
    //       this.centerZip = response.data["GetCoordinatesResult"];
    //     });
    //   loadModules(
    //     [
    //       "esri/Map",
    //       "esri/views/MapView",
    //       "esri/layers/FeatureLayer",
    //       "esri/layers/GraphicsLayer",
    //       "esri/Graphic"
    //     ],
    //     { css: true }
    //   ).then(([ArcGISMap, MapView, FeatureLayer, GraphicsLayer, Graphic]) => {
    //     const territorymap = new ArcGISMap({
    //       basemap: "gray"
    //     });
    //     var zipcodes = new FeatureLayer({
    //       url:
    //         "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/USA_ZIP_Codes/FeatureServer/0"
    //     });
    //     var graphicsLayer = new GraphicsLayer();
    //     territorymap.add(graphicsLayer);
    //     var mouseover_graphicsLayer = new GraphicsLayer({
    //       labelingInfo: [zipcodeLabels]
    //     });
    //     territorymap.add(mouseover_graphicsLayer);
    //     var view = new MapView({
    //       container: "my_map",
    //       map: territorymap,
    //       center: [this.centerZip.Longitude, this.centerZip.Latitude],
    //       zoom: 4
    //     });
    //     view.when(function() {
    //       var centerZip = {
    //         geometry: view.center,
    //         distance: 25,
    //         units: "miles",
    //         spatialRelationship: "intersects",
    //         outFields: ["ZIP"],
    //         returnGeometry: true,
    //         where: "ZIP = '32033'"
    //       };
    //       zipcodes
    //         .queryFeatures(centerZip)
    //         .then(function(result) {
    //           addGraphics(result, true);
    //           zoomToGraphics(result, true);
    //         })
    //         .then(function() {
    //           var query = {
    //             geometry: view.center,
    //             distance: 25,
    //             units: "miles",
    //             spatialRelationship: "intersects",
    //             outFields: ["ZIP"],
    //             returnGeometry: true,
    //             where: "1=1"
    //           };
    //           zipcodes.queryFeatures(query).then(function(result) {
    //             addGraphics(result, true);
    //           });
    //         });
    //     });
    //     function zoomToGraphics(result) {
    //       result.features.forEach(function(feature) {
    //         view.goTo(feature.geometry).then(function() {
    //           view.scale = 240000;
    //         });
    //         graphicsLayer.removeAll();
    //       });
    //     }
    //     function queryFeatureLayer(
    //       point,
    //       distance,
    //       spatialRelationship,
    //       sqlExpression
    //     ) {
    //       var query = {
    //         geometry: point,
    //         distance: distance,
    //         units: "miles",
    //         spatialRelationship: spatialRelationship,
    //         outFields: ["ZIP"],
    //         returnGeometry: true,
    //         where: sqlExpression
    //       };
    //       zipcodes.queryFeatures(query).then(function(result) {
    //         addGraphics(result, true);
    //       });
    //     }
    //     view.on("pointer-move", function(evt) {
    //       var screenPoint = {
    //         x: evt.x,
    //         y: evt.y
    //       };
    //       view.hitTest(screenPoint).then(function(response) {
    //         getGraphics(response);
    //       });
    //     });
    //     function getGraphics(response) {
    //       if (response.results.length) {
    //         var graphic = response.results[0].graphic;
    //         addSingleGraphic(graphic);
    //       }
    //     }
    //     function addSingleGraphic(graphic) {
    //       mouseover_graphicsLayer.removeAll();
    //       var g = new Graphic({
    //         geometry: graphic.geometry,
    //         attributes: graphic.attributes,
    //         symbol: {
    //           type: "simple-fill", // autocasts as new SimpleFillSymbol()
    //           color: [255, 128, 0, 0.7],
    //           outline: {
    //             // autocasts as new SimpleLineSymbol()
    //             width: 1,
    //             color: "black"
    //           }
    //         }
    //       });
    //       var h = new Graphic({
    //         geometry: graphic.geometry,
    //         attributes: graphic.attributes,
    //         symbol: {
    //           type: "text",
    //           text: graphic.attributes["ZIP"],
    //           font: {
    //             // autocasts as new Font()
    //             size: 8,
    //             weight: "bold"
    //           }
    //         }
    //       });
    //       mouseover_graphicsLayer.add(g);
    //       mouseover_graphicsLayer.add(h);
    //     }
    //     var zipcodeLabels = {
    //       symbol: {
    //         type: "text",
    //         color: "#000",
    //         //haloColor: "#5E8D74",
    //         //haloSize: "2px",
    //         font: {
    //           size: "8px",
    //           family: "Noto Sans",
    //           style: "italic",
    //           weight: "normal"
    //         }
    //       },
    //       labelPlacement: "center-center",
    //       labelExpressionInfo: {
    //         expression: "$feature.ZIP"
    //       }
    //     };
    //     function addGraphics(result) {
    //       result.features.forEach(function(feature) {
    //         var g = new Graphic({
    //           geometry: feature.geometry,
    //           attributes: feature.attributes,
    //           symbol: {
    //             type: "simple-fill",
    //             color: [255, 128, 0, 0.1],
    //             outline: {
    //               width: 1,
    //               color: "black"
    //             }
    //           },
    //           popupTemplate: {
    //             title: "{ZIP}",
    //             content: "This a trail located in {ZIP}."
    //           }
    //         });
    //         graphicsLayer.add(g);
    //       });
    //     }
    //   });
    // },
    // beforeDestroy() {
    //   if (this.view) {
    //     this.view.container = null;
    //   }
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#my_map {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 600px;
  box-sizing: content-box;
  display: flex;
  line-height: normal;
}
</style>
